import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';
import {ISpecialization} from './specialization.interface';
import {cloneDeep} from 'lodash';
import {firstValueFrom} from 'rxjs';


export interface IRSpecialization {
  specializations: ISpecialization[];
}

export namespace SpecializationAction {
  export class Get {
    static readonly type = '[SPECIALIZATIONS] Get Specializations Action';
    constructor() { }
  }
}

@State<IRSpecialization>({
  name: 'Specialization',
  defaults: {
    specializations: []
  }
})

@Injectable()
export class SpecializationState {
  constructor(
    private baseService: BaseService<any>
  ) { }

  url = environment.SERVER_URL;

  @Selector()
  static getSpecializations(state: IRSpecialization): ISpecialization[] {
    return state.specializations;
  }

  @Action(SpecializationAction.Get)
  async getSpecializationsAction(ctx: StateContext<IRSpecialization>, _: SpecializationAction.Get): Promise<void> {
    const specializations = cloneDeep(ctx.getState()?.specializations || []);
    if (specializations.length > 0) return;

    const response: DataBaseServiceResponse<ISpecialization[]> = await firstValueFrom(
      this.baseService.get(`${this.url}/specializations`)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({
      specializations: response.entity
    });
  }
}
